import { MdWarning } from "react-icons/md";
import Badge from "components/badge";
import Card, { CardHeader } from "components/card";
import { EmptyState } from "components/states";

const BlockersPanel = ({ summary }) => {
  if (!summary) return null;

  const blockers = summary.topBlockers || [];
  const hasBlockers = blockers.length > 0;

  return (
    <Card padding="md">
      <CardHeader
        title="Blockers This Week"
        actions={
          <Badge tone={hasBlockers ? "warning" : "success"}>
            {summary.blockerCount} reported
          </Badge>
        }
      />
      {hasBlockers ? (
        <ul className="mt-4 space-y-3">
          {blockers.map((blocker, index) => (
            <li
              key={index}
              className="flex items-start gap-3 rounded-control bg-warning-subtle p-3"
            >
              <MdWarning aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-warning-fg" />
              <p className="text-sm text-fg">{blocker}</p>
            </li>
          ))}
        </ul>
      ) : (
        <EmptyState variant="inline" title="No blockers reported this week" />
      )}
    </Card>
  );
};

export default BlockersPanel;
